import React, { Component } from "react"
import {FormTable} from './FormTable'
import { auth, db } from '../../../service';

export class FormUpdate extends Component {

    constructor(props) {
        super(props)
        this.state = {
            datas: [],

            user: null
        }

    }
    componentDidMount(){
       const user_id = this.props.match.params.user_id
        db.collection('dares').doc('lts').collection('tuug').get().then((querySnapshot) => {
            const data = querySnapshot.data()
            console.log(data)
        }).catch((error) => {
            alert(error)
        })

    }
    render() {
        const user_id = this.props.match.params.user_id
        const {datas} = this.state
        return (
            <div className="main-content">
                {user_id}

            </div>
        )

    }

}
